/* eslint-disable no-param-reassign, no-useless-escape */
export default {
  validateEmail: (text) => {
    const regex = /^[a-z0-9]+([._+-][a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/i;
    return regex.test(String(text).toLowerCase());
  },
  getCollectionIdFromURL: (path) => {
    return path.includes('id-')
      ? path.substring(path.lastIndexOf('-') + 1)
      : '';
  },
  getFiscalYear: (corporateInformation) => {
    return !corporateInformation.fiscalYear
      ? (new Date()).getFullYear().toString().slice(2, 6)
      : corporateInformation.fiscalYear.toString().slice(2, 6);
  }
};
